"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var GrowthPlan = /*#__PURE__*/function () {
  function GrowthPlan(client) {
    (0, _classCallCheck2["default"])(this, GrowthPlan);
    this.client = client;
    this.resourceUrl = '/session';
  }

  (0, _createClass2["default"])(GrowthPlan, [{
    key: "getSession",
    value: function getSession() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl), args);
    }
  }, {
    key: "openSession",
    value: function openSession(data, sessionId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(sessionId, "/mark-listened-read"), data, args);
    }
  }, {
    key: "listenSessionAudio",
    value: function listenSessionAudio(data, sessionId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(sessionId, "/mark-listened-read"), data, args);
    }
  }, {
    key: "getSessionForClient",
    value: function getSessionForClient(sessionId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(sessionId, "/client"), args);
    }
  }, {
    key: "getScheduling",
    value: function getScheduling(clientId, questId) {
      var url = "/sows/client/".concat(clientId, "/scheduling");

      if (questId) {
        url += "?questId=".concat(questId);
      }

      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getAvailableSlots",
    value: function getAvailableSlots(coachId) {
      var _this$client;

      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return (_this$client = this.client).post.apply(_this$client, ["/calendar/coach/".concat(coachId, "/available-slots"), payload].concat(args));
    }
  }, {
    key: "scheduleFirstSession",
    value: function scheduleFirstSession() {
      var _this$client2;

      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return (_this$client2 = this.client).post.apply(_this$client2, ['/calendar/schedule-first-session', payload].concat(args));
    }
  }, {
    key: "rescheduleSession",
    value: function rescheduleSession(coachId) {
      var _this$client3;

      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
      }

      return (_this$client3 = this.client).post.apply(_this$client3, ["/calendar/coach/".concat(coachId, "/reschedule-event"), payload].concat(args));
    }
  }, {
    key: "scheduleRemainingSessions",
    value: function scheduleRemainingSessions() {
      var _this$client4;

      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return (_this$client4 = this.client).post.apply(_this$client4, ['/calendar/schedule-remaining-sessions', payload].concat(args));
    }
  }, {
    key: "cancelSession",
    value: function cancelSession(coachId, eventId) {
      var _this$client5;

      for (var _len10 = arguments.length, args = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        args[_key10 - 2] = arguments[_key10];
      }

      return (_this$client5 = this.client)["delete"].apply(_this$client5, ["/calendar/coach/".concat(coachId, "/events/").concat(eventId)].concat(args));
    }
  }, {
    key: "checkSlotAvailability",
    value: function checkSlotAvailability(coachId) {
      var _this$client6;

      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        args[_key11 - 2] = arguments[_key11];
      }

      return (_this$client6 = this.client).post.apply(_this$client6, ["/calendar/coach/".concat(coachId, "/check-slot-availability"), payload].concat(args));
    }
  }, {
    key: "scheduleAllSessions",
    value: function scheduleAllSessions() {
      var _this$client7;

      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return (_this$client7 = this.client).post.apply(_this$client7, ['/calendar/schedule-all-sessions', payload].concat(args));
    }
  }]);
  return GrowthPlan;
}();

exports["default"] = GrowthPlan;